import { useEffect } from "react"
import type { FC, ReactElement } from "react"

import { useLocation } from "react-router-dom"

const ScrollToTopGuard: FC = (): ReactElement => {
    const { pathname, search } = useLocation()

    useEffect((): void => void window.scrollTo({ top: 0, behavior: "smooth" }), [pathname, search])

    return null
}

ScrollToTopGuard.displayName = "ScrollToTopGuard"

export { ScrollToTopGuard }
